export default {"src":"/_next/static/media/Vector-quarter-circle3.153349d7.svg","height":116,"width":232,"blurWidth":0,"blurHeight":0};